import React, { FC } from 'react';
import { Category } from '../../../pages/learn/articles';
import { Article } from '../../../pages/learn/articles/[slug]';
import AngleButton from '../../AngleButton';
import OrangeDivider from '../../OrangeDivider';
import ArticleCard from '../ArticleCard';

interface Props {
  category: Category;
  articles: Array<Article>;
  limitArticles?: boolean;
  isLandingPage: boolean;
}

const ArticlesByCategory: FC<Props> = ({ category, articles, limitArticles, isLandingPage }) => {
  if (articles.length === 0) return null;
  return (
    <div className='mt-32'>
      {isLandingPage ? (
        <div>
          <OrangeDivider className={'h-1 w-12'} />
          <h4 className='mt-2'>{category.title}</h4>
        </div>
      ) : null}
      <div className='mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-8'>
        {articles.map((article, index) =>
          !limitArticles || index < 6 ? (
            <div className='h-56'>
              <ArticleCard key={article.slug} article={article} />
            </div>
          ) : null
        )}
      </div>
      {articles.length > 6 && limitArticles && (
        <div className='mt-8'>
          <AngleButton text='View All' link={`articles/${category.slug}`} />
        </div>
      )}
    </div>
  );
};

export default ArticlesByCategory;
